import React, { useState, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { FaTimes, FaChevronLeft, FaChevronRight, FaImage } from 'react-icons/fa';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import './WelcomeModal.css';

const WelcomeModal = ({ isOpen, onClose, posters }) => {
  const [show, setShow] = useState(true);
  const [loadedImages, setLoadedImages] = useState({});
  const swiperRef = useRef(null);
  const location = useLocation();

  const handleClose = () => {
    setShow(false);
    if (onClose) onClose();
  };

  const handleImageLoad = (index) => {
    setLoadedImages((prev) => ({ ...prev, [index]: true }));
  };

  const postersList = Array.isArray(posters) ? posters : (posters ? [posters] : []);

  if (location.pathname !== '/' || !show || postersList.length === 0) {
    return null;
  }

  const hasMultiple = postersList.length > 1;

  return (
    <div className="wm-overlay" onClick={handleClose}>
      <div className="wm-box" onClick={(e) => e.stopPropagation()}>
        {/* Tombol tutup */}
        <button className="wm-close" onClick={handleClose} aria-label="Tutup">
          <FaTimes />
        </button>

        {/* Slider */}
        <Swiper
          modules={[Autoplay, Pagination]}
          spaceBetween={0}
          slidesPerView={1}
          pagination={hasMultiple ? { clickable: true } : false}
          autoplay={hasMultiple ? { delay: 5000, disableOnInteraction: false } : false}
          loop={hasMultiple}
          onSwiper={(swiper) => { swiperRef.current = swiper; }}
          className="wm-swiper"
        >
          {postersList.map((poster, index) => {
            const isLoaded = loadedImages[index];
            const imageUrl = poster.url || poster;
            const hasButton = poster.buttonText && poster.buttonLink;

            return (
              <SwiperSlide key={poster.id || poster.public_id || index}>
                <div className="wm-slide">
                  <div className="wm-image-container">
                    {/* Skeleton shimmer loading state */}
                    {!isLoaded && (
                      <div className="wm-skeleton">
                        <div className="wm-skeleton-shimmer"></div>
                        <div className="wm-skeleton-icon">
                          <FaImage />
                          <span>Memuat Informasi...</span>
                        </div>
                      </div>
                    )}

                    {/* Poster Image */}
                    <img
                      src={imageUrl}
                      alt={`Informasi Sekolah ${index + 1}`}
                      className={`wm-image ${isLoaded ? 'wm-image-loaded' : 'wm-image-loading'}`}
                      onLoad={() => handleImageLoad(index)}
                    />
                  </div>

                  {/* Button CTA */}
                  {hasButton && (
                    <a
                      href={poster.buttonLink}
                      className={`wm-btn ${!isLoaded ? 'wm-btn-disabled' : ''}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {poster.buttonText}
                    </a>
                  )}
                </div>
              </SwiperSlide>
            );
          })}
        </Swiper>

        {/* Custom navigation — hanya muncul jika ada lebih dari 1 poster */}
        {hasMultiple && (
          <>
            <button
              className="wm-nav wm-nav-prev"
              onClick={() => swiperRef.current?.slidePrev()}
              aria-label="Sebelumnya"
            >
              <FaChevronLeft />
            </button>
            <button
              className="wm-nav wm-nav-next"
              onClick={() => swiperRef.current?.slideNext()}
              aria-label="Berikutnya"
            >
              <FaChevronRight />
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default WelcomeModal;